export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-screen flex items-center bg-white pt-16">
      <div className="w-full max-w-6xl mx-auto px-6 py-20">
        <div className="text-center max-w-4xl mx-auto">
          <p className="text-sm font-medium text-[#1E3A8A] tracking-wide mb-6 animate-fade-in">
            LONG ISLAND'S TRUSTED DIGITAL PARTNER FOR SMALL BUSINESSES
          </p>
          
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-semibold text-neutral-900 leading-[1.05] tracking-tight mb-8">
            Grow your
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#1E3A8A] to-[#1E40AF]">
              local business
            </span>
          </h1>
          
          <p className="text-lg md:text-xl text-neutral-500 max-w-2xl mx-auto mb-8 leading-relaxed font-light">
            Professional <strong>website design</strong>, <strong>video production</strong>, and <strong>digital marketing</strong> for small businesses across <strong>Nassau</strong> and <strong>Suffolk County</strong>.
          </p>

          <a 
            href="tel:+16316407888"
            className="inline-flex items-center gap-3 text-2xl md:text-3xl font-semibold text-neutral-900 hover:text-[#1E3A8A] transition-colors mb-10 cursor-pointer"
          >
            <span className="w-12 h-12 rounded-full bg-[#1E3A8A] flex items-center justify-center">
              <i className="ri-phone-fill text-white text-xl"></i>
            </span>
            (631) 640-7888
          </a>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => scrollToSection('start-project')}
              className="bg-neutral-900 text-white px-8 py-4 rounded-full text-sm font-medium hover:bg-neutral-800 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Start Your Project
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="bg-neutral-100 text-neutral-900 px-8 py-4 rounded-full text-sm font-medium hover:bg-neutral-200 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Explore Services
            </button>
          </div>
        </div>

        <div className="mt-24 relative">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-neutral-200/50">
            <img 
              src="https://public.readdy.ai/ai/img_res/13dc97d648d186fb5af5cf1afff2df68.jpg"
              alt="Long Island Website Design and Video Production Services"
              title="Professional website design and video production for Long Island small businesses"
              className="w-full h-auto object-cover"
            />
          </div>
          
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-white rounded-full px-6 py-3 shadow-lg shadow-neutral-200/50 flex items-center gap-3">
            <span className="w-2 h-2 bg-[#1E3A8A] rounded-full animate-pulse"></span>
            <span className="text-sm font-medium text-neutral-600">Serving Nassau & Suffolk County</span>
          </div>
        </div>

        {/* Service Areas */}
        <div className="mt-20 text-center">
          <p className="text-xs font-medium text-neutral-400 tracking-wide mb-4">PROUDLY SERVING</p>
          <p className="text-sm text-neutral-500 max-w-3xl mx-auto leading-relaxed">
            Huntington • Babylon • Islip • Smithtown • Brookhaven • Oyster Bay • Hempstead • Riverhead • Southampton • Massapequa • Levittown • Hicksville • Commack • Bay Shore • Patchogue
          </p>
        </div>
      </div>
    </section>
  );
}